import * as ActionTypes from "constants/ActionTypes";
import { combineReducers } from "redux";

function overflowChapterNumbersVisibility(state = false, action) {
  switch (action.type) {
    case ActionTypes.TOGGLE_TOP_NAV_OVERFLOW_CHAPTERS:
      return !state;
    case ActionTypes.SET_ROUTE_DATA:
      return false; // When the route is set then return false
    default:
      return state;
  }
}

export default combineReducers({
  overflowChapterNumbersVisibility,
});
